import {ThemeTypesEnum} from './themeTypes';
import {UserTheme} from './userThemeProvider';

export const isDarkSidebarTheme = (theme: UserTheme) => theme.type === ThemeTypesEnum.DARK_SIDEBAR;
export const isExpandedDarkTheme = (theme: UserTheme) => theme.type === ThemeTypesEnum.EXPANDED_DARK;
export const isDarkTheme = (theme: UserTheme) => isDarkSidebarTheme(theme) || isExpandedDarkTheme(theme);
